var _rect, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_58_249",
    transform: "translate(0.145833) scale(0.00787037 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_58_249",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAESUlEQVR4nO3cv28bZRjA8e9ztAMdUBbEiJQNVUjI5wyIDlFg6n8AiI17IzEhVaidiLMAlUBiQXLO6hSpQzsAA1MrlCI1A3CeSlYEFUsTiXQqUkkehvpEArbznu89++7e9ztZ9uv3rI9O98v2QSgUCoVCoVAoFArVNFn0B6hDSZK8JiJXgDXgReARcDeKos/7/f4DF8vwHtoYcwW4Djw35uW/gQ/TNP2q7HLGTe5Nxpge8AkQTRgSAZe73e5RlmU/lFmWt9Aj5A3L4Wtlsb2ELoicVwrbO+gZkfNmxvYKuiRy3kzY3kA7Qs4rjO0FtGPkvLU4jg+yLPvJZvCkw5qQXV8mSXLRZqAXa3SWZTtxHAuw6njqKIqiC1mWfXvmQMcLrm1pmvaATdfzquqbNuO8gYbKsF+yGeQVNFSC/chmkHfQ4BZbVb+3GdcaaGNMb3QYZ5Uj7CNV/cJmYCuOOk4cJ6/GcSxZlu3YvK/s0YiIfDQYDL6xGdt46DEnI6udTuf54XB41+b9WZbtdLvdv4C3Ci66l6bpZ7aDGw096YxPRC4VxL5fELuXpmmhzU5joc86ra4QuzAyNBTa9tpFBdgzIUMDoYteIHKIPTMyNAx61qtwDrBLIUODoMte6hSRSwUP/e6PDv3ulUWGhvzcwOX1ZFW9PhgMrrmYq0i1X6NdX7QvuhlxVa2hK/pmZCHYtYWuCjlv3ti1hK4aOW+e2LWDnhdy3rywa3WZdN7IeSLypPJlVL0A2xaFjIOTEZtqAd12ZKgBtA/IsGBoX5BhgdA+IcOCoH1DhgVA+4gMc4b2FRnmCO0zMswJ2ndkmAN0QH5WpdAB+d8qgw7Ip6sEOiD/P+fQAXl8TqED8uScQQfk6TmBDshnVxo6INtV6stZY8z54+Pjx1EU3QIeAK8ALzj5ZNPbbBIyON4Zrq+vv66quy7nHNPm6P8njcrpt+Cq+jPPbo9TVY1EBsfQaZo+BR67nPNEvaYiQzW/66gCulE7vnFVAX3oeL7G7fjGda6COf90OFfj1+Q852u0qrqCbg0yVLPp+N3BHK3YXJysijX6u5JTNPYQblqFzgyNMa/GcfzBtD/cDIfDX1dWVu6p6j7wm6o+FJF94AB4AhwDFya8vZXIUPDM0BjzKXCNkiBJklwUkV1On663FhmKbToEeHv0eKPILRv+22Aw+AW4ceKpViNDAWhjzBvAyyeeKoWtqj+OHrYeGQpAq+q7Y57eSJLE+lYKpxYcRfs0/LS6SFY7Q2PMeRG5wZidWNF/pOYtLy//sb29bXWbnDZkBd3pdC6LyPtThhS6GQnA3t7eke3YNmS76XjnrAEicnXWzYgPWUGLiNWdWQL25GwvKj21GPMQ+FpVb5f4PK3NClpVt0Xk6piXDkTklojc7Pf7u4C6/XjtyQr68PDw46WlJUTkPeCciNwBbqrqna2tLZu1PRQKhUKhUCgUCoVCde0fyxkODJZeL+0AAAAASUVORK5CYII="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c949f925fbf87037c846a9592baaf802.svg";
export { ForwardRef as ReactComponent };